var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#7E7E7E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.232 12.625h1.474V14H9.232v-1.375zm-1.75-3.982c0-.403.06-.77.177-1.1.125-.33.3-.612.528-.847a2.38 2.38 0 01.836-.539c.33-.132.697-.198 1.1-.198.337 0 .649.051.935.154.293.095.546.238.759.429.22.183.392.414.517.693.125.279.187.594.187.946 0 .257-.03.48-.088.671a1.624 1.624 0 01-.22.484c-.088.132-.19.253-.308.363l-.352.308c-.14.117-.268.231-.385.341-.117.11-.22.235-.308.374a1.65 1.65 0 00-.21.473 2.92 2.92 0 00-.065.671H9.397c0-.323.015-.594.044-.814.037-.227.092-.425.165-.594.073-.169.161-.315.264-.44.11-.132.238-.26.385-.385.117-.103.227-.198.33-.286.11-.088.205-.183.286-.286.088-.11.154-.231.198-.363.051-.132.077-.29.077-.473 0-.22-.04-.407-.121-.561a1.104 1.104 0 00-.275-.385 1.09 1.09 0 00-.352-.209 1.01 1.01 0 00-.33-.066c-.455 0-.792.15-1.012.451-.213.293-.32.69-.32 1.188H7.484z",
    fill: "#7E7E7E"
  })));
};

export default SvgHelp;